var _defs, _polygon, _polygon2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSymbolpackNew195({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#fff;}"))), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "a",
    points: "13.06 9.87 2.94 9.87 0.39 9.87 0.39 10.87 0.39 13.87 2.94 13.87 2.94 10.87 13.06 10.87 13.06 13.87 15.61 13.87 15.61 10.87 15.61 9.87 13.06 9.87"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    className: "a",
    points: "2.94 6.13 13.06 6.13 15.61 6.13 15.61 5.13 15.61 2.13 13.06 2.13 13.06 5.13 2.94 5.13 2.94 2.13 0.39 2.13 0.39 5.13 0.39 6.13 2.94 6.13"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSymbolpackNew195);
export default __webpack_public_path__ + "static/media/Symbolpack_New_195.1d5f97e964b6634382acf4bed50944c1.svg";
export { ForwardRef as ReactComponent };